import { useEffect, useState } from "react";
import { Capacitor } from "@capacitor/core";
import { api } from "@/services/api";

interface UpdateInfo {
  version: string;
  apkUrl: string | null;
}

export const useUpdateChecker = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updateInfo, setUpdateInfo] = useState<UpdateInfo | null>(null);

  useEffect(() => {
    // Vérification uniquement sur l'app native Android
    if (!Capacitor.isNativePlatform()) return;

    const currentVersion = import.meta.env.VITE_APP_VERSION as string;

    api
      .get<UpdateInfo>("/version")
      .then(({ data }) => {
        if (data.version !== currentVersion) {
          setUpdateInfo(data);
          setUpdateAvailable(true);
        }
      })
      .catch(() => {
        // Silencieux — pas bloquant si l'API est injoignable
      });
  }, []);

  const dismiss = () => setUpdateAvailable(false);

  return { updateAvailable, updateInfo, dismiss };
};
